import { z } from 'zod';
import { IndicatorType, LiquidationIndicatorMode } from '@shared/types';
import { ZigZagInputSchema } from './zig-zag.schema';

export const LiquidationConfirmationInvalidationModeSchema = z.enum([
  'WICK',
  'CLOSE'
]);
export type LiquidationConfirmationInvalidationMode = z.infer<
  typeof LiquidationConfirmationInvalidationModeSchema
>;

export const LiquidationIndicatorModeSchema = z.nativeEnum(
  LiquidationIndicatorMode
);

export const LiquidationInputSchema = z.object({
  type: z.literal(IndicatorType.LIQUIDATION),
  mode: LiquidationIndicatorModeSchema.default(
    LiquidationIndicatorMode.LIQUIDATION
  ),
  zigZag: ZigZagInputSchema,
  pivotLookback: z.number().int().min(1).max(20).optional(),
  reclaimWithinCandles: z.number().int().min(0).max(50).optional(),
  confirmationCandles: z.number().int().min(0).max(50).optional(),
  confirmationInvalidationMode:
    LiquidationConfirmationInvalidationModeSchema.optional(),
  minBreakPercent: z.number().min(0).max(10).optional(),
  minReactionPercent: z.number().min(0).max(20).optional()
});

export type LiquidationInput = z.infer<typeof LiquidationInputSchema>;
